export const errorTextkeys = [
	'MOBILE_UPLOAD_DOC_FILES_IS_GREATER_THEN_2MB',
	'MOBILE_UPLOAD_DOCUMENTS_FETCH_API_ERROR',
	'MOBILE_UPLOAD_DOCUMENTS_UPLOAD_API_ERROR'
];

export const textKeys = [
	'MOBILE_UPLOAD_DOCUMENTS_PENDING',
	'MOBILE_UPLOAD_DOCUMENTS_HEAD_TITLE',
	'MOBILE_UPLOAD_DOCUMENTS_AFF_SUBTITLE',
	'MOBILE_UPLOAD_DOCUMENTS_AFF_TITLE',
	'MOBILE_UPLOAD_DOCUMENTS_AFF_BUTTON',
	'MOBILE_SPENDING_LIMIT_OR_TEXT',
	'MOBILE_UPLOAD_DOCUMENTS_AFF_BUTTON_PRIMARY',
	'BUTTON_CUSTOMER_SUPPORT'
];

export const DOC_URI = '/doc/aff';
export const FILE_SIZE = 6 * 1000000;
